import { serviceName } from '../resources/serviceConstants';
import { appendServiceNameToURL, appendServicePortToURL } from '../resources/serviceURLs';
import {
  HOME_DASHBOARD,
  HOME_DASHBOARD_FILTERS,
  HOME_DASHBOARD_EXPORT,
} from '../resources/endPoint';

export const buildHomeDashboardApiUrl = (path) => {
  const serviceURL = appendServiceNameToURL(serviceName.PROJECT_MS);
  const servicePort = appendServicePortToURL(serviceName.PROJECT_MS);
  const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

  if (process.env.NODE_ENV === 'production') {
    return `${baseUrl}${serviceURL}/api${path}`;
  }

  return `${baseUrl}:${servicePort}${serviceURL}/api${path}`;
};

export const getHomeDashboardFilters = (userInfo = null) => ({
  url: HOME_DASHBOARD_FILTERS,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: true,
  payload: userInfo ? { userInfo } : {},
  service: serviceName.PROJECT_MS,
});

export const getHomeDashboardData = (payload) => ({
  url: HOME_DASHBOARD,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: true,
  payload,
  service: serviceName.PROJECT_MS,
});

export const getHomeDashboardExportData = (payload) => ({
  url: HOME_DASHBOARD_EXPORT,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: true,
  payload,
  service: serviceName.PROJECT_MS,
});
